import { render } from "./record-attempt-view.vue?vue&type=template&id=1cdf42e4"
import script from "./record-attempt-view.vue?vue&type=script&lang=js"
export * from "./record-attempt-view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__